import React, { useState, useEffect } from 'react';
import './CardLike.css';
import axios from 'axios';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useUser } from '../UserContext';

const CardLike = ({ cardid, contestid, initialLiked = false }) => {
    const [liked, setLiked] = useState(initialLiked);
    const [likers, setLikers] = useState([]); // This state is fetched but not currently used in renderTooltip
    const [showLikers, setShowLikers] = useState(false); // Controls tooltip visibility
    const { cards, setCards } = useUser();

    useEffect(() => {
        setLiked(initialLiked);
        fetchLikers();
    }, [cardid, initialLiked]);

    const fetchLikers = async () => {
        try {
            const response = await axios.get(`/api/contest/likers.php?card_id=${cardid}&contest_id=${contestid}`);
            setLikers(response.data); // Likers data is available if you want to use it in the tooltip later
        } catch (error) {
            console.error('Error fetching likers:', error);
        }
    };

    const handleClick = async () => {
        try {
            const response = await axios.post('/api/contest/like.php', { card_id: cardid, contest_id: contestid });
            const newLikedState = response.data.liked;
            setLiked(newLikedState);
            
            if (cards && setCards) {
                const updatedCards = cards.map(card => {
                    if (parseInt(card.id) === parseInt(cardid)) {
                        return { ...card, liked: newLikedState ? 1 : 0 };
                    }
                    return card;
                });
                setCards(updatedCards);
            }
            
            fetchLikers(); // Refresh the likers list (though not displayed in current tooltip)
        } catch (error) {
            console.error('Error submitting like:', error);
        }
    };

    const renderTooltip = (props) => (
        <Tooltip id="liker-list-tooltip" {...props}>
            <div>{liked ? 'Remove' : 'Vote'}</div>
        </Tooltip>
    );

    return (
        <div className="card-like-action-area"> {/* Wrapper for button and text below it */}
            <OverlayTrigger
                placement="top" // Changed to 'top' for better UX, tooltip appears above the button
                show={showLikers}
                overlay={renderTooltip}
                onToggle={(show) => setShowLikers(show)}
                delay={{ show: 250, hide: 100 }} // Optional: adds a small delay for tooltip appearance/disappearance
            >
              <Button
                  variant="outline-danger"
                    size="lg"
                    className={`like-button-bootstrap ${liked ? 'liked' : ''}`}
                    onClick={handleClick}
                    aria-label={liked ? 'Remove Vote' : 'Vote for this card'} // For accessibility
                >
                    {liked ? '❤️' : '🤍'}
                </Button>
            </OverlayTrigger>
            <div className="vote-action-text"> {/* Text displayed under the button */}
                {liked ? 'Remove' : 'Vote'}
            </div>
        </div>
    );
};

export default CardLike;